/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Coordinator} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  coordinator: Coordinator
  display: boolean
}

const CoordinatorInfoCell: FC<Props> = ({coordinator, display = false}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(coordinator.id)
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a style={{display:(!display) ? 'none' : ''}}
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {coordinator.name}
        </a>
        <span style={{display:(display) ? 'none' : ''}}
        >
          {coordinator.name}
        </span>
      </div>
    </div>
  )
}

export {CoordinatorInfoCell}
